const FAKE_CONTAINER_PRODUCTS = {
  desktop: 4,
  mobile: 4,
  tablet: 4,
};

module.exports = { FAKE_CONTAINER_PRODUCTS };
